import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

const CommonProviders = ({ children }) => (
  <StrictMode>
    {children}
  </StrictMode>
);

CommonProviders.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommonProviders;
